import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import ChartTabs from "./ChartTabs";

import { useNavigate, useParams, Link } from "react-router-dom";
import Header from "../common/Header/Header";
import Footer from "../common/Footer/Footer";
import { GetToken } from "../common/getToken";
import axios from "axios";
import { Error } from "../common/Error";
import Swal from "sweetalert2";
import SurveyDescription from "./SurveyDescription";

import Cookies from "js-cookie";

const Home = () => {
  /* get REACT_APP_API_URL from .env file */
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;
  const { REACT_APP_CookieURL } = process.env;
  const { REACT_APP_ANALYTICS_BASE_URL } = process.env;

  /* get values from URL parameters */
  const { surveyId } = useParams() || "";

  const [loading, setLoading] = useState(false);

  const [userSurveys, setUserSurveys] = useState([]);
  const [surveyDetails, setSurveyDetails] = useState([]);
  const [surveyDescription, setSurveyDescription] = useState([]);

  const [overview, setOverview] = useState([]);

  /* variable declarations */
  let history = useNavigate();

  const overviewData = () => {
    // console.log("%cOESS", "color:#32c5ff;font-family:system-ui;font-size:4rem;font-weight:bold");
    setLoading(true);
    axios
      .get(`${REACT_APP_API_URL}/getSingleSurveyAnalytics/${surveyId}`, {
        headers: {
          authorization: GetToken(),
        },
      })
      .then(async (result) => {
        console.log(result);
        if (result.status === 200) {
          if (result.data.data) {
            setLoading(false);
            if (result.data.message) {
              Swal.fire({
                title: result.data.message,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Back",
                cancelButtonText: "Cancel",
              }).then((result) => {
                if (result.isConfirmed) {
                  history.goBack();
                }
              });
            } else if (result.data.data) {
              setUserSurveys(result.data.data.UserSurveys);
              setSurveyDetails(result.data.data.surveyDetails);
              setSurveyDescription(
                result.data.data.surveyDetails.surveySettings[
                  "Rk09Rk77-1d18-11ec-a7ce-de3d953443b5"
                ]["value"],
              );

              /*
              setOverview(
                result.data.data.surveyAnalytics.map((p, index) => ({
                  Question: index + 1,
                  ...p,
                }))
              );
              */
            } else {
              history.goBack();
            }
          } else {
            Error(404, "No data found.");
            history.goBack();
          }
        }
      })
      .catch((err) => {
        /*
        setLoading(false);
        if (err.response) {
         
        } else {
          Error(404, "Something went wrong.");
        } */
      });
  };

  const getUserData = async () => {
    setLoading(true);

    /* get user data */
    if (GetToken()) {
      await axios
        .get(`${REACT_APP_API_URL}/user`, {
          headers: {
            Authorization: GetToken(),
          },
        })
        .then((result) => {
          if (result.data.data) {
            localStorage.setItem(
              "user",
              window.btoa(JSON.stringify(result.data.data)),
            );
            setLoading(false);
            overviewData();
          } else {
            setLoading(false);
            Error(404, "invalid credentials");

            setTimeout(() => {
              window.location = `${REACT_APP_BASE_URL}/login`;
            }, 5000);
          }
        })
        .catch((err) => {
          setLoading(false);
          Error(404, "Something went wrong.");
        });
    } else {
      setLoading(false);
      Error(404, "Please Login");
      setTimeout(() => {
        window.location = `${REACT_APP_BASE_URL}/login`;
      }, 5000);
    }
  };

  useEffect(() => {
    const createAuthLogin = () => {
      Error(404, "invalid credentials");

      /*
      axios
        .post(`${REACT_APP_API_URL}/AnalyticsLogin`, { survey_id: surveyId })
        .then(async (result) => {
          if (result.status) {
            await getUserData(result.data.access_token, true);
            sessionStorage.setItem("analytics_token", result.data.access_token);
            window.location = `${REACT_APP_ANALYTICS_BASE_URL}/home/${surveyId}`;
          }
        })
        .catch((err) => {
          if (err.response) {
            Error(404, "invalid credentials");
            // } else if (err.request) {
            //   Error(err.request.status, err.request.data.message);
          } else {
            Error(404, "Something went wrong.");
          }
        });
        */
    };

    getUserData();
  }, [
    history,
    REACT_APP_API_URL,
    REACT_APP_BASE_URL,
    REACT_APP_ANALYTICS_BASE_URL,
    surveyId,
  ]);

  return (
    <>
      {loading ? (
        <>
          <center
            style={{ paddingTop: "40vh" }}
            className={loading ? "" : "d-none"}
          >
            <br />
            <h4>Loading...</h4>
          </center>
        </>
      ) : (
        <>
          <div className={!loading ? "" : "d-none"}>
            <Header
              BASE_URL={REACT_APP_BASE_URL}
              CookieURL={REACT_APP_CookieURL}
              surveyDetails={surveyDetails}
              userSurveys={userSurveys}
              history={history}
            />
            <SurveyDescription
              IntroductionText={surveyDetails.IntroductionText}
              surveyDetails={surveyDetails}
              surveyDescription={surveyDescription}
            />

            <Container className="min-height">
              <ChartTabs
                overview={overview}
                surveyDetails={surveyDetails}
                REACT_APP_API_URL={REACT_APP_API_URL}
                BASE_URL={REACT_APP_BASE_URL}
                surveyId={surveyId}
              />
            </Container>

            <Footer />
          </div>
        </>
      )}
    </>
  );
};

export default Home;
